import React from 'react';
import TopPageHeader from '../PageHeader';
import { PageBody, PrimaryColumn, SecondaryColumn } from './PageBody';
import './page-layout.css';

function PageLayout({ title, subtitle, primary, secondary }) {
  const hasSecondary = secondary !== null && secondary !== undefined && secondary !== false;

  return (
    <div className="mp-page-layout">
      <TopPageHeader />
      <div className="mp-page-shell">
        <header className="mp-page-heading">
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </header>

        <PageBody className={!hasSecondary ? 'is-single-column' : ''}>
          <PrimaryColumn>{primary}</PrimaryColumn>
          {hasSecondary ? <SecondaryColumn>{secondary}</SecondaryColumn> : null}
        </PageBody>
      </div>
    </div>
  );
}

export default PageLayout;
